import { Routes } from '@angular/router';
import { AuthGuard } from '../core';
import { LayoutComponent } from './layout';

export enum DigidocsExternalRouteParams {
  DOC_ID = 'docId',
  SIGNATURE_ID = 'signatureId',
}

export const ROUTES: Routes = [
  {
    path: `search-assignments/sign`,
    loadComponent: () =>
      import(
        './search-assignments/components/search-assignment-external-sign/search-assignment-external-sign.component'
      ).then(m => m.SearchAssignmentExternalSignComponent),
  },
  {
    path: 'salary-terms/:docId/sign/:signatureId',
    loadComponent: () =>
      import(
        './allocations/modules/salary-terms/components/salary-terms-external-sign/salary-terms-external-sign.component'
      ).then(m => m.SalaryTermsExternalSignComponent),
  },
  {
    path: 'workstation-sheet/:docId/sign/:signatureId',
    loadComponent: () =>
      import(
        './allocations/modules/workstation-sheets/components/workstation-sheet-external-sign/workstation-sheet-external-sign.component'
      ).then(m => m.WorkstationSheetExternalSignComponent),
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: 'candidate-leads', pathMatch: 'full' },
      {
        path: 'inflow-generator',
        loadChildren: () =>
          import('./inflow-generator/inflow-generator.routes').then(m => m.ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'candidate-leads',
        loadChildren: () => import('./candidate-leads/candidate-leads.routes').then(m => m.ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'matching-list',
        loadChildren: () => import('./matching-list/matching-list.routes').then(m => m.ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'employees',
        loadChildren: () => import('./employees/employees.routes').then(m => m.ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'companies',
        loadChildren: () => import('./companies/companies.routes').then(m => m.ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'allocations',
        loadChildren: () => import('./allocations/allocations.routes').then(m => m.ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'events',
        loadChildren: () => import('./events/events.routes').then(m => m.ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'vacancies',
        loadChildren: () => import('./vacancies/vacancies.routes').then(m => m.ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'matching',
        loadChildren: () => import('./matching/matching.routes').then(m => m.ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'vacancy-applications-list',
        loadComponent: () =>
          import('./vacancy-applications-list/vacancy-applications-list.component').then(
            m => m.VacancyApplicationsListComponent
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'leads',
        loadChildren: () => import('./leads/leads.routes').then(m => m.ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'watch-tower',
        loadChildren: () => import('./control-tower/control-tower.routes').then(m => m.ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'search-assignments',
        loadChildren: () =>
          import('./search-assignments/search-assignments.routes').then(m => m.ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'cockpit',
        loadComponent: () =>
          import('./power-bi-dashboard/power-bi-dashboard.component').then(
            m => m.PowerBiDashboardComponent
          ),
        canActivate: [AuthGuard],
      },
      { path: '**', redirectTo: 'candidate-leads' },
    ],
  },
];
